import { forwardRef } from 'react';
import { Text } from '@weareconceptstudio/core';

//* Styles
import TagStyle from './style';

const Tag = forwardRef(({ text, isActive = false, className = '', onClick }, ref) => {
	return (
		<TagStyle
			ref={ref}
			className='tag-container'
			onClick={(val) => onClick?.(val)}
		>
			<Text
				className={`tag-wrapper p p1 montserrat-500 capitalize ${className} ${isActive ? 'active' : ''}`}
				text={text}
			/>
		</TagStyle>
	);
});

Tag.displayName = 'Tag';

export default Tag;
